export default __webpack_public_path__ + "static/media/group-10@2x.f828bf15.png";